import { apiClient, getBackendApiUrl, resolveBackendHost } from "@/api/apiClient.js";
import createCarbonApi from "./carbonApi.js";

const carbonApi = createCarbonApi({
    apiClient,
    baseUrl: getBackendApiUrl(),
    hostResolver: resolveBackendHost,
});

export default carbonApi;
